import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DateUtilService } from 'gung-common';
import { ListItemRendererComponent } from 'gung-list';
import { AuthService, CustomerService, OrderRow } from 'gung-standard';
import { first } from 'rxjs';
import { HlDisplayPortalFeaturesService, PriceSettingsGroup } from '../../services/hl-display-portal-features.service';

@Component({
  selector: 'app-hl-display-order-lines-table',
  templateUrl: './hl-display-order-lines-table.component.html',
  styleUrls: ['./hl-display-order-lines-table.component.css'],
  standalone: false
})
export class HlDisplayOrderLinesTableComponent extends ListItemRendererComponent<OrderRow[]> {
  public dateUtilService = inject(DateUtilService);
  protected customerService = inject(CustomerService);
  protected route = inject(ActivatedRoute);
  protected authService = inject(AuthService);
  protected hlDisplayPortalFeaturesService = inject(HlDisplayPortalFeaturesService);


  isLoading: boolean = true;
  currency: string;

  protected hidePrices: boolean = false;

  ngOnInit(): void {
    const routeParams = this.route.snapshot.params;
    this.customerService.getCustomer(routeParams.customerId).pipe(first()).subscribe(customer => {
      this.currency = customer.extra.kus.valkod;
      this.isLoading = false;
    });

    this.hlDisplayPortalFeaturesService
      .getPortalFeatureGroup('priceSettingsGroup')
      .pipe(first())
      .subscribe(priceSettingsGroup => {
        this.hidePrices = (priceSettingsGroup as PriceSettingsGroup)?.hidePrices;
      });
  }
}
